import { Outlet } from 'react-router';
import { AccountMenu, Branding, DashboardLayout, NavigationItem } from 'layouts/DashboardLayout';
import AdminSearch from './AdminSearch';
import useSchoolContext from 'hooks/useSchoolContext';
import useAuthContext from 'hooks/useAuthContext';

interface AdminLayoutProps {
  navItems?: NavigationItem[]
}

export function AdminLayout({ navItems }: AdminLayoutProps): JSX.Element {
  const schoolContext = useSchoolContext();
  const { user } = useAuthContext();

  // branding for appbar
  const branding: Branding = {
    title: schoolContext?.name,
    logo: <img src={schoolContext?.logoImage} alt="Logo" style={{ maxHeight: '100%' }} />,
    homeUrl: '/admin'
  };

  return (
    <DashboardLayout
      navItems={navItems}

      appbarSlots={{
        actions: AdminSearch,
        accountMenu: AccountMenu,
      }}
      appbarSlotProps={{
        appTitle: {
          branding: branding
        },
        accountMenu: {
          // avatarColor: '#007AFF',
          // avatarImg: 'https://lh3.googleusercontent.com/a/ACg8ocJRW18is3kxbRoPVwNKKTf1-xm6BvQ4odE7GebfXxJM6skaQ1U6=s192-c-mo',
          name: `${user?.first_name ?? ''} ${user?.last_name ?? ''}`,
          email: user?.email,
        },
      }}
    >
      <Outlet />
    </DashboardLayout>
  );
}

export default AdminLayout;
